import POOL_ABI from 'abis/ShibaWorldCupPool.json'
import BigNumber from 'bignumber.js'
import { STAKE_POOL_ADDRESS } from 'constants/addresses'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ZERO } from 'utils/bigNumber'
import multicall from 'utils/multicall'

import { WalletPoolData } from '../types'

/**
 * Gets all wallet data of token contract
 */
const useWalletPoolData = (chainId: number): WalletPoolData => {
  const { account } = useActiveWeb3React()
  const poolAddress = STAKE_POOL_ADDRESS[chainId]
  const { slowRefresh } = useRefresh()

  const [state, setState] = useState({
    isInPool: false,
    stakedBal: BIG_ZERO,
    startTime: 0,
    pendingBal: BIG_ZERO,
  })

  const fetchWalletPoolData = useCallback(async () => {
    const userCalls = [
      {
        address: poolAddress,
        name: 'isInPool',
        params: [account],
      },
      {
        address: poolAddress,
        name: 'getWalletInfo',
        params: [account],
      },
      {
        address: poolAddress,
        name: 'getPendingBal',
        params: [account],
      },
    ]

    const [isInPool, walletInfo, pendingBal] = await multicall(chainId, POOL_ABI, userCalls)

    setState((prev) => ({
      ...prev,
      isInPool: Boolean(isInPool[0]),
      stakedBal: new BigNumber(walletInfo[0].toString()),
      startTime: Number(walletInfo[1]),
      pendingBal: new BigNumber(pendingBal[0].toString()),
    }))
  }, [account, chainId, poolAddress])

  useEffect(() => {
    if (account) {
      fetchWalletPoolData()
    }
  }, [account, fetchWalletPoolData, slowRefresh])

  return { ...state, fetchWalletPoolData }
}

export default useWalletPoolData
